import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    children?: React.ReactNode;
}

export const StickyHeaderLayout = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);

    return (
        <S_StickyHeaderLayout className={props.className} $isFixed={!ctxEventView.isPreview}>
            {props.children}
        </S_StickyHeaderLayout>
    );
};

const S_StickyHeaderLayout = styled.div<{ $isFixed: boolean }>`
    position: relative;
    top: 0;
    z-index: 3;
    position: ${(props) => (props.$isFixed ? 'fixed' : 'absolute')};
    width: 100%;
`;
